import _ from 'lodash'
import NEWSLETTER_FOOTER_SUBSCRIBE_CONFIG from './config'
import API from '../../core/api'
import API_HINT from '../../core/api-hint'
import API_PROGRESS from '../../core/api-progress'
import CAPTCHA from '../../core/google-recaptcha'

class NewsletterFooterSubscribeClass {
    constructor() {
        this.DOM = {
            form: NEWSLETTER_FOOTER_SUBSCRIBE_CONFIG.form
        }

        this.endpoint = NEWSLETTER_FOOTER_SUBSCRIBE_CONFIG.endpoint

        this.DOM.form ? this.init() : null
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.form.addEventListener( 'submit', this._captcha.bind( this ) )
    }

    _captcha() {
        CAPTCHA._verify( this.DOM.form, this._submit.bind( this ) ) 
    }

    _submit() {
        API_PROGRESS._loading( this.DOM.form )

        API.post( this.endpoint, 
            new FormData( this.DOM.form )
        )
        .then( ( response ) => {
            if ( response.data.success ) {
                API_HINT._open( 'is--success', response.data.message )
                setTimeout( () => { API_HINT._close() }, API_HINT.timeout )
            } else {
                API_HINT._open( 'is--error', response.data.message )
            }
            
        })
        .catch( ( err ) => {
            console.log( err )
            API_HINT._open( 'is--error', API_HINT.error )
        })
        .then( () => {
            API_PROGRESS._loaded( this.DOM.form )
        })

    }

}

const NEWSLETTER_FOOTER_SUBSCRIBE = new NewsletterFooterSubscribeClass()
export default NEWSLETTER_FOOTER_SUBSCRIBE